<template>
	<div :class="tooltipClasses">
		<div :class="['map-tooltip-header', 'map-tooltip-header-' + hoveredFeatureData.service]">
			{{ $t('home-map.tooltip.headers.' + featureType + '.' + hoveredFeatureData.service) }}
		</div>
		<div class="map-tooltip-content">
			<Table
				v-if="hoveredFeatureData.userAttempts"
				:columns="getterFailedTooltipTableColumns"
				:data-source="hoveredFeatureData.userAttempts"
				:pagination="false"
				size="small"
			/>
		</div>
	</div>
</template>

<script lang="ts">
import { computed } from 'vue';
import type { PropType } from 'vue';

import { useLocaleData } from '@/locales/useLocaleData';

import { Table } from 'ant-design-vue';

import Consts from '@/api/Consts';
import type { FeatureType, VRSParticipantRoverFeatureData } from '@/components/map/types/mapFeatureTypes';

export default {
	components: {
		Table,
	},
	props: {
		hoveredFeatureData: {
			type: Object as PropType<VRSParticipantRoverFeatureData>,
			required: true,
		},
		featureType: {
			type: String as PropType<FeatureType>,
			required: true,
		},
	},
	setup() {
		const { localeData } = useLocaleData();
		const tooltipClasses = computed(() => [
			'map-tooltip-style',
			'map-tooltip-position-' + localeData.value.direction,
			'no-pointer-events',
		]);
		return {
			getterFailedTooltipTableColumns: Consts.getterFailedTooltipTableColumnsComp,
			tooltipClasses,
		};
	}
};
</script>

<style scoped>
@import '@/assets/map-tooltip.css';
</style>